import styled from 'styled-components';
import { colors } from 'styles/colors';
import { MASKED_TEXT_CLASS } from 'analytics/constants';
import { AccordionContent, AccordionItem, AccordionTrigger } from 'components';

export const AnamnesisAccordionItem = styled(AccordionItem).attrs({
  className: 'border-b-0',
})``;

export const AnamnesisAccordionTrigger = styled(AccordionTrigger).attrs({
  variant: 'arrow',
  className: 'items-center py-1.5 text-xs hover:no-underline [&>svg:first-child]:translate-y-0',
})``;

export const AnamnesisAccordionContent = styled(AccordionContent).attrs({
  className: 'pb-2',
})``;

export const AnamnesisCard = styled.div.attrs({
  className: 'mb-3 rounded-lg border border-border bg-card p-4 shadow-sm',
})``;

export const AnamnesisDetails = styled.div.attrs({
  className: 'space-y-3 text-base',
})``;

export const AnamnesisRow = styled.div.attrs({
  className: 'flex flex-col gap-2',
})``;

export const AnamnesisLabel = styled.span.attrs({
  className: 'font-semibold',
})``;

export const AnamnesisTitle = styled.h3.attrs({
  className: 'text-lg font-bold text-foreground',
})``;

export const AnamnesisValue = styled.span``;

export const SummaryText = styled.div.attrs<{ $clamped?: boolean }>((props) => ({
  className: [
    'rounded-md text-base whitespace-pre-wrap flex-1 min-w-0',
    props.$clamped
      ? 'overflow-hidden text-ellipsis [display:-webkit-box] [-webkit-line-clamp:2] [-webkit-box-orient:vertical]'
      : '',
    MASKED_TEXT_CLASS,
  ].join(' '),
}))<{ $clamped?: boolean }>``;

export const BoldText = styled.span.attrs({ className: 'font-semibold' })``;

export const SummarySectionsList = styled.div.attrs({
  className: ['grid grid-cols-[auto_1fr] gap-x-6 gap-y-1 leading-snug', MASKED_TEXT_CLASS].join(
    ' '
  ),
})``;

export const SummarySectionHeading = styled.span.attrs({
  className: 'font-semibold',
})``;

export const SummarySectionContent = styled.span.attrs({
  className: 'text-xs',
})``;

export const SummaryItemRed = styled.span`
  color: ${colors.danger};
`;

export const AdditionalFilesNotice = styled.div.attrs({
  className: 'col-span-2 mt-1 font-semibold',
})``;

export const VisitReasonContent = styled.div.attrs({
  className: 'flex flex-col gap-2 items-start',
})``;

export const VisitReasonHeader = styled.div.attrs({
  className: 'flex flex-wrap items-center gap-2',
})``;

export const VisitReasonChips = styled.div.attrs({
  className: 'flex flex-wrap gap-2',
})``;

export const VisitReasonChip = styled.span.attrs<{ $color: string }>({
  className: 'px-2 py-1 text-xs font-medium border rounded-md',
})<{ $color: string }>`
  background-color: ${({ $color }) => $color || colors.midnightBlue};
  border-color: ${({ $color }) => $color || colors.midnightBlue};
  color: ${colors.primaryForeground};
`;

export const VisitReasonText = styled.div.attrs<{ $clamped?: boolean }>((props) => ({
  className: [
    'text-xs whitespace-pre-wrap flex-1 min-w-0',
    props.$clamped
      ? 'overflow-hidden text-ellipsis [display:-webkit-box] [-webkit-line-clamp:1] [-webkit-box-orient:vertical]'
      : '',
  ].join(' '),
}))<{
  $clamped?: boolean;
}>``;

export const VisitReasonBoldText = styled.span.attrs({
  className: `font-semibold ${MASKED_TEXT_CLASS}`,
})``;

export const VisitReasonColoredText = styled.span.attrs<{ $color: string }>({
  className: MASKED_TEXT_CLASS,
})<{ $color: string }>`
  color: ${({ $color }) => $color || 'inherit'};
`;

export const ShowMoreButton = styled.button.attrs({
  className:
    'text-foreground font-bold text-xs leading-[18px] underline decoration-solid underline-offset-2 tracking-normal [text-decoration-skip-ink:auto] focus:outline-none shrink-0 whitespace-nowrap',
})``;

export const VisitReasonLine = styled.div.attrs<{ $stacked?: boolean }>((props) => ({
  className: [
    'w-full flex gap-2',
    props.$stacked ? 'flex-col items-start gap-1' : 'items-baseline',
  ].join(' '),
}))<{ $stacked?: boolean }>``;
